'use strict';

/**
 *  Handling first tab and adding focus ring for keyboard users
 *  This solve the problem that in specific situations, the mouse click adds the outline that we don't want
 *  Working with relation to styles for .user-is-tabbing class from _reset.scss
 *
 * @returns {void}
 */
export function handleFirstTab() {
  window.addEventListener('keydown', addTabbingBodyClass);
}

function addTabbingBodyClass(event) {
  if (event.key === 'Tab' || event.keyCode === 9) {
    document.body.classList.add('user-is-tabbing');
    window.removeEventListener('keydown', addTabbingBodyClass);
  }
}
